import { useForm } from "react-hook-form";
import { IHU, IReserve } from "../../Interfaces";
import * as yup from "yup";
import Button from "../Button";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useHabUnits } from "../../Providers/HabUnit";
import { useGuests } from "../../Providers/Guests";
import { Container } from "./styles";
import DatePicker from "react-date-picker";
interface FormReserveProps {
  reserve?: IReserve;
  HU: IHU;
  closeModal: () => void;
}

interface IDataSearch {
  guestCPF: string;
}

const FormReserve = ({ reserve, HU, closeModal }: FormReserveProps) => {
  const { guests } = useGuests();
  const { addReserve, editReserve } = useHabUnits();

  const [userInput, setUserInput] = useState<string>("");
  const [date, onChange] = useState<Date>(new Date());

  const onSubmit = (data: IDataSearch) => {
    const selectedGuest =
      guests.find((el) => el.cpf === data.guestCPF) || guests[1];

    const newReserve = {
      date: date.toLocaleString("pt-BR").split(" ")[0],
      guest: selectedGuest,
    };
    if (reserve !== undefined) {
      editReserve(reserve, HU, newReserve);
    } else {
      addReserve(newReserve, HU);
    }
    closeModal();
  };

  const formSchema = yup.object().shape({
    guestCPF: yup.string().required("Campo obrigatório"),
  });
  const { register, handleSubmit } = useForm<IDataSearch>({
    resolver: yupResolver(formSchema),
    defaultValues: {
      guestCPF: reserve?.guest.cpf,
    },
  });

  return (
    <Container onSubmit={handleSubmit(onSubmit)}>
      <DatePicker value={date} onChange={onChange} />
      <input
        type="text"
        value={userInput}
        onChange={(e) => setUserInput(e.target.value)}
        placeholder={reserve ? reserve.guest.cpf : "CPF"}
        className="search"
      />
      <div className="selectGuests">
        <label htmlFor={"listNames"}>Hospedes</label>
        <select {...register("guestCPF")} id="listNames" name="guestCPF">
          {guests
            ?.filter((el) => el.cpf.includes(userInput))
            ?.map((el) => (
              <option key={el.id} value={el.cpf}>
                {el.name}
              </option>
            ))}
        </select>
      </div>
      {reserve ? (
        <Button className="submit" type="submit">
          Editar
        </Button>
      ) : (
        <Button className="submit" type="submit">
          Criar
        </Button>
      )}
    </Container>
  );
};

export default FormReserve;
